import FullModal from '../FullModal';
import PrivacyPolicyForm from '../../component/privacy/PrivacyPolicyForm';
import { useSetRecoilState } from 'recoil';
import { privacyPolicyStateRecoil } from '../../atom/ModalAtom';

const PrivacyPolicy = () => {
  const setModalState = useSetRecoilState(privacyPolicyStateRecoil);

  const handleClose = () => {
    setModalState(false);
  };

  return (
    <>
      <FullModal onClose={handleClose}>
        <PrivacyPolicyForm />
      </FullModal>
    </>
  );
};

export default PrivacyPolicy;
